import { buildQueryParams, getResData, httpClient } from "utils";

import { BILLS_RECALCULATION_API_PATHS } from "./consts";
import {
  BillsRecalculationCountDTO,
  BillsRecalculationFilterQuery,
} from "./types";

export const getBillsRecalculationActive = (): Promise<boolean> =>
  httpClient
    .get<boolean>(BILLS_RECALCULATION_API_PATHS.ACTIVE)
    .then(getResData);

export const getBillsRecalculationCount = (
  query: BillsRecalculationFilterQuery,
): Promise<BillsRecalculationCountDTO> =>
  httpClient
    .post<BillsRecalculationCountDTO>(
      `${BILLS_RECALCULATION_API_PATHS.COUNT}?${buildQueryParams(
        query as Record<
          string,
          string | number | boolean | string[] | number[]
        >,
      )}`,
    )
    .then(getResData);

export const previewBillsRecalculation = (
  query: BillsRecalculationFilterQuery,
): Promise<void> =>
  httpClient.post(
    `${BILLS_RECALCULATION_API_PATHS.PREVIEW}?${buildQueryParams(
      query as Record<string, string | number | boolean | string[] | number[]>,
    )}`,
  );

export const runBillsRecalculation = (
  query: BillsRecalculationFilterQuery,
): Promise<void> =>
  httpClient.post(
    `${BILLS_RECALCULATION_API_PATHS.RUN}?${buildQueryParams(
      query as Record<string, string | number | boolean | string[] | number[]>,
    )}`,
  );

// GUID mode — the backend accepts a plain-text body, one GUID per line.
const PLAIN_TEXT_REQUEST_CONFIG = { headers: { "Content-Type": "text/plain" } };

export const getBillsRecalculationCountByGuids = (
  guids: string,
): Promise<BillsRecalculationCountDTO> =>
  httpClient
    .post<BillsRecalculationCountDTO>(
      BILLS_RECALCULATION_API_PATHS.COUNT,
      guids,
      PLAIN_TEXT_REQUEST_CONFIG,
    )
    .then(getResData);

export const previewBillsRecalculationByGuids = (
  guids: string,
): Promise<void> =>
  httpClient.post(
    BILLS_RECALCULATION_API_PATHS.PREVIEW,
    guids,
    PLAIN_TEXT_REQUEST_CONFIG,
  );

export const runBillsRecalculationByGuids = (guids: string): Promise<void> =>
  httpClient.post(
    BILLS_RECALCULATION_API_PATHS.RUN,
    guids,
    PLAIN_TEXT_REQUEST_CONFIG,
  );
